module.exports = "var content = \"Hello World\"\n\nprint(src: content)"